import { types, cast, getSnapshot, applySnapshot } from 'mobx-state-tree';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
const FeeUnit = types.model({
  id: types.maybeNull(types.string),
  value: types.optional(types.number, 0),
  feeUnitType: types.string
});
const FeeTypeUnit = types.model({
  id: types.string,
  name: types.string
});
export const FeeStructure = types.model({
  feesTypes: types.optional(types.array(FeeTypeUnit), []),
  fees: types.optional(types.array(FeeUnit), [
    // {
    //   id: 'TenantAccountMaintenance',
    //   value: 0,
    //   feeUnitType: FEE_UNIT_TYPES.fixedAmount,
    // },
    // {
    //   id: 'OwnerAccountMaintenance',
    //   value: 5,
    //   feeUnitType: FEE_UNIT_TYPES.fixedAmount,
    // },
  ]),
  feesValidation: true
}).views(store => ({
  getFeeUnitValue(id) {
    const findIdx = store.fees.findIndex(item => item.id === id);
    if (findIdx !== -1) {
      return store.fees[findIdx].value;
    }
    return false;
  },
  getFeeUnitType(id) {
    const findIdx = store.fees.findIndex(item => item.id === id);
    if (findIdx !== -1) {
      return store.fees[findIdx].feeUnitType;
    }
  }
})).actions(store => {
  let afterLoadState;
  return {
    initAfterLoadState() {
      try {
        afterLoadState = getSnapshot(store);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    applyAfterLoadState() {
      try {
        applySnapshot(store, afterLoadState);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    validateFees(value) {
      try {
        store.feesValidation = value;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    changesFeesTypes(data) {
      try {
        store.feesTypes = cast(data);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    changeFeesAfterLoadData(data) {
      try {
        store.fees = cast([]);
        data.map(feeItem => {
          const currentFeeType = store.feesTypes.find(item => item.id === feeItem.feeId);

          //TODO: delete after release MVP
          const feeToUpdate = ['LateFee', 'TenantAccountMaintenance', 'OwnerAccountMaintenance'];
          if (currentFeeType && currentFeeType.name && feeToUpdate.includes(currentFeeType.name)) {
            store.fees.push({
              id: currentFeeType.name,
              value: feeItem.value,
              feeUnitType: FEE_UNIT_TYPES[feeItem.feeUnitType.toLowerCase()]
            });

            // if (
            //   currentFeeType.name === feeToUpdate[2] &&
            //   feeItem.value === 10
            // ) {
            //   store.fees.push({
            //     id: feeToUpdate[1],
            //     value: 0,
            //     feeUnitType:
            //       feeItem.feeUnitType === 2
            //         ? FEE_UNIT_TYPES.fixedAmount
            //         : FEE_UNIT_TYPES.percentage,
            //   });
            // }
          }
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    changeFeeUnit(id, data) {
      try {
        const findIdx = store.fees.findIndex(item => item.id === id);
        if (findIdx !== -1) store.fees[findIdx].value = data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    addFeeUnit(data) {
      try {
        var _data$feeUnitType;
        store.fees.push({
          id: data.id,
          value: data.value || 0,
          feeUnitType: (_data$feeUnitType = data === null || data === void 0 ? void 0 : data.feeUnitType) !== null && _data$feeUnitType !== void 0 ? _data$feeUnitType : FEE_UNIT_TYPES.fixedAmount
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    removeFeeUnit(id) {
      try {
        const findIdx = store.fees.findIndex(item => item.id === id);
        store.fees.splice(findIdx, 1);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    updateFeeUnitType(id, data) {
      try {
        const findIdx = store.fees.findIndex(item => item.id === id);
        if (findIdx !== -1) store.fees[findIdx].feeUnitType = data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
});